import React from "react"

function IconBookmark({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="bookmark"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-bookmark"
      {...props}
    >
      <path
        d="M16.364 3.71H7.636c-.964 0-1.745.78-1.745 1.745v13.713c0 .263.058.518.17.751l.052.092c.218.314.67.38.969.12L12 15.828l4.918 4.301a.655.655 0 0 0 1.022-.21c.11-.234.17-.49.17-.752V5.455c0-.964-.782-1.746-1.746-1.746zm0 1.308.088.009c.198.04.348.217.348.428v12.833l-4.37-3.82-.086-.064a.655.655 0 0 0-.775.064L7.2 18.287V5.455c0-.241.195-.437.436-.437h8.728z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconBookmark
